import { useState } from 'react';
import { useAuth } from '@/providers/authProvider';

export function Login() {
  const { loginMutation } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password || loginMutation.isPending) return;
    loginMutation.mutate({ email, password });
  };

  const inputClass =
    'w-full rounded-xl border border-muted bg-card px-4 py-3 text-[15px] font-semibold text-ink placeholder:font-semibold placeholder:text-faint focus:border-sub focus:outline-none';

  return (
    <div className="flex h-full flex-col justify-center px-[26px] pb-16">
      <div className="mb-1 text-[28px] font-extrabold leading-[1.1] text-ink">Zeosphere</div>
      <div className="mb-7 text-sm font-semibold text-faint">Companion</div>
      <form onSubmit={submit} className="flex flex-col gap-[9px]">
        <input
          type="email"
          autoComplete="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={inputClass}
        />
        <input
          type="password"
          autoComplete="current-password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={inputClass}
        />
        <button
          type="submit"
          disabled={loginMutation.isPending}
          className="mt-2 rounded-xl bg-primary py-3 text-[15px] font-bold text-primary-text disabled:opacity-60"
        >
          Sign in
        </button>
        {loginMutation.isError && (
          <div className="mt-1 text-[13px] font-semibold text-danger">
            Email or password didn't match
          </div>
        )}
      </form>
    </div>
  );
}
